// extracted by mini-css-extract-plugin
module.exports = {"trashIconWrapper":"RasmusUserKid_trashIconWrapper_1zeog"};